module.exports = "<h1><alg-icon class=\"main-icon\" [icon]=\"actualIcon\"></alg-icon> {{title}}</h1>\n<div (click)=\"toggle\" class=\"opener\" *ngIf=\"status != 'disable'\">\n  <span l10nTranslate *ngIf=\"open === true\" class=\"opener-message\">COLLAPSE</span>\n  <span l10nTranslate *ngIf=\"open === false\" class=\"opener-message\">EXPANDE</span>\n  <alg-icon class=\"collapse-icon\" [icon]=\"collapseIcon\"></alg-icon>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/molecules/alg-accordion-header/alg-accordion-header.component.html
// module id = ./src/app/components/molecules/alg-accordion-header/alg-accordion-header.component.html
// module chunks = main